import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { map } from 'rxjs/operators';

@Injectable()
export class ProgramListService {

  constructor(private base: BaseService) { }  

  getProgramInfo(id) {
    return this.base.post('/api/view-organization-program',{id:id});
  }

  getAllProgram(data){
    return  this.base.post('/api/all-program-by-status', data);
  }

  updateProgramStatus(data) {
    return  this.base.post('/api/update-program-status', data);
  }

}
